// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 2076 ? "common" : chunkId) + "." + {"2076":"9a42ad8c","8154":"94521352"}[chunkId] + ".chunk.css";
};